module.exports = __webpack_public_path__ + "static/media/icon-bottom-referral.e441b82d.svg";